import { HttpClient } from '@angular/common/http';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { HttpHelperService } from 'src/app/core/services/http-helper.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { TransactionSupDocsService } from 'src/app/pages/transaction/services/transaction-sup-docs.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "../../../core/services/http-helper.service";
import * as i3 from "@angular/common/http";
import * as i4 from "../../../core/services/ls-helper.service";
import * as i5 from "../../../core/services/auth.service";
import * as i6 from "../../transaction/services/transaction.service";
import * as i7 from "../../transaction/services/transaction-sup-docs.service";
export class TransactionRequestService extends BaseProvider {
    constructor(globals, httpHelper, http, ls, authService, transactionService, transactionSupDocsService) {
        super();
        this.globals = globals;
        this.httpHelper = httpHelper;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.transactionService = transactionService;
        this.transactionSupDocsService = transactionSupDocsService;
        this.mode = 'list';
        this.tryEdit = false;
        this.requestList = [];
        this.baseUrl = "userProcessRequest";
    }
    getRequests() {
        if (this.transactionService.itemToEdit.Id) {
            return new Promise((resolve, reject) => {
                this.url = this.globals.dataUrl + this.baseUrl +
                    '/request/' + this.transactionService.itemToEdit.Id;
                this.http.get(this.url)
                    .subscribe((data) => {
                    this.pageData(data.Data);
                    this.requestList = data.Data;
                    this.transactionSupDocsService.getDocs();
                    resolve(data);
                }, err => { reject(err); });
            });
        }
    }
    update(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/update/" + data.Id;
            this.http
                .put(this.url, data)
                .subscribe((resp) => {
                this.updateItem(data);
                resolve(resp);
            }, err => { reject(err); });
        });
    }
    tryUpdate(data) {
        this;
    }
    createRequest(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, Object.assign({}, params, { UserProcessId: this.transactionService.itemToEdit.Id }))
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    canEdit() {
        //User has 'can manage documents' policy
        //Transaction is not finished
        let hasPolicy = false;
        hasPolicy = this.authService.hasPolicyBool("CanAddRequests");
        this.canAddRequests = hasPolicy;
        return hasPolicy;
    }
    canView() {
        //User has 'can view documents' policy
        let hasPolicy = false;
        hasPolicy = this.authService.hasPolicyBool("CanViewRequests");
        this.canViewRequests = hasPolicy;
        return hasPolicy;
    }
    delete(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                "/delete/" + params.Id;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    createDoc(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/createDoc/' + this.transactionService.itemToEdit.Id;
            console.log(params);
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getDocs() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/process/' + this.transactionService.itemToEdit.Id +
                '/page/' + this.page +
                '/size/' + this.size;
            this.http.get(this.url)
                .subscribe((data) => {
                if (this.page == 1) {
                    this.list = data.Data;
                }
                else {
                    this.pushItems(data.Data);
                }
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
TransactionRequestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionRequestService_Factory() { return new TransactionRequestService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpHelperService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LsHelperService), i0.ɵɵinject(i5.AuthService), i0.ɵɵinject(i6.TransactionService), i0.ɵɵinject(i7.TransactionSupDocsService)); }, token: TransactionRequestService, providedIn: "root" });
